
  import createMeisterIcons from '../src/createMeisterIcons';

  const Frame964 = createMeisterIcons("frame 964", [["g",{"stroke":"#000","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"1.5","clip-path":"url(#a)","key":"fabd54c0b4d57f4f71c6697447c2c1bf47cdf31d","fillRule":"evenodd","clipRule":"evenodd"}],["defs",{"key":"4abe992d71821d874e13a518ce88e86a2557199e","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Frame964
  